import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    // Extract reference from content and dispatch event
    this.dispatchReference()
  }

  dispatchReference() {
    const content = this.element.textContent
    const match = content.match(/\[REFERENCE:([^\]]+)\]/)
    if (!match) return
    
    const reference = match[1]
    
    // Dispatch a custom event that will be caught by the translation scroll controller
    const event = new CustomEvent('translation-scroll:scrollToReference', {
      detail: { reference: reference },
      bubbles: true
    })
    
    this.element.dispatchEvent(event)

    // Remove the reference text from the display
    const referenceText = `[REFERENCE:${reference}]`
    const contentElement = this.element.querySelector('.message-content')
    if (contentElement) {
      contentElement.innerHTML = contentElement.innerHTML.replace(referenceText, '')
    }
  }
}
